var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('s-button',{attrs:{"is-loading":_vm.loggingOut,"color":"primary"},on:{"click":_vm.logout}},[_vm._v(" "+_vm._s(_vm.$t('signOut'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }